"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isQuebecOrganization = exports.showProudOfCanada = void 0;
const country_1 = require("../enums/country");
const region_1 = require("../region");
const showProudOfCanada = (country) => {
    return country === country_1.OrganizationCountry.Canada;
};
exports.showProudOfCanada = showProudOfCanada;
const isQuebecOrganization = (country, region) => {
    return (0, region_1.isQuebec)(country, (0, region_1.resolveRegionCode)(country, region));
};
exports.isQuebecOrganization = isQuebecOrganization;
